export const HEADER_OFFSET = 88;

/**
 * Smoothly scrolls to a landing-page section by id.
 * Returns false when the element is not in the DOM.
 */
export function scrollToSection(id, { smooth = true } = {}) {
  if (typeof window === "undefined") return false;
  if (id === "home") {
    window.scrollTo({ top: 0, behavior: smooth ? "smooth" : "auto" });
    return true;
  }
  const el = document.getElementById(id);
  if (!el) return false;
  const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
  window.scrollTo({ top: Math.max(0, top), behavior: smooth ? "smooth" : "auto" });
  return true;
}

export const LANDING_SECTIONS = ["home", "about", "services", "usecases", "contact"];
export const LANDING_PATHS = ["/", "/about", "/services", "/usecases", "/contact"];
